// extracted by mini-css-extract-plugin
export default {"buttonBig":"Buttons_buttonBig__rBieP","button":"Buttons_button__ogmur","icon":"Buttons_icon__Ded1r","iconMask":"Buttons_iconMask__hsOsP","foreground":"Buttons_foreground__ywhTl"};